<template>
  <a-modal
    :title="`${actType}账号`"
    centered
    :width="640"
    :mask-closable="false"
    :visible="showForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-spin :spinning="loading">
        <a-form-model-item label="账号" prop="username">
          <a-input v-model="model.username"/>
        </a-form-model-item>
        <a-form-model-item label="角色" prop="role_id">
          <a-select placeholder="请选择" :default-value="model.role_id" v-model="model.role_id">
            <template v-if="roles.length > 0">
              <a-select-option :value="role.id" v-for="role in roles" :key="role.id">
                {{ role.name }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="密码" prop="password">
          <a-input-password :placeholder="model.id ? '不修改请留空' : ''" v-model="model.password" autocomplete="off"/>
        </a-form-model-item>
        <a-form-model-item label="姓名" prop="name">
          <a-input v-model="model.name"/>
        </a-form-model-item>
        <a-form-model-item label="绑定主体" prop="corporation_ids" help="绑定主体后只能查看和管理对应主体相关数据">
          <a-select mode="multiple" placeholder="请选择" :default-value="model.corporation_ids" v-model="model.corporation_ids">
            <a-select-option :value="corporation.id" v-for="corporation in corporations" :key="corporation.id">
              {{ corporation.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="绑定小组" prop="team_ids" help="绑定小组后只能查看和管理对应小组相关数据">
          <a-select mode="multiple" placeholder="请选择" :default-value="model.team_ids" v-model="model.team_ids">
            <a-select-option :value="team.id" v-for="team in teams" :key="team.id">
              {{ team.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="绑定优化师" prop="worker_ids" help="绑定优化师后只能查看和管理对应优化师相关数据">
          <a-select mode="multiple" placeholder="请选择" :default-value="model.worker_ids" v-model="model.worker_ids">
            <a-select-option :value="worker.id" v-for="worker in workers" :key="worker.id">
              {{ worker.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <!-- <a-form-model-item label="素材账户" prop="material_ids" help="绑定素材账户后只能查看和管理对应素材账户的素材">
          <a-select placeholder="请选择" v-model="model.material_ids" mode="multiple" :default-value="model.material_ids">
            <a-select-option :value="admin.id" v-for="admin in admins" :key="admin.id">
              {{ admin.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item> -->

        <a-form-model-item label="素材账户" prop="material_ids" help="绑定素材账户后只能查看和管理对应素材账户的素材">
          <a-select 
            placeholder="请选择" 
            v-model="model.material_ids" 
            show-search
            allow-clear
            mode="multiple" 
            :default-value="model.material_ids"
            @change="handleMaterialChange"
          >
            <!-- 添加全选选项 -->
            <a-select-option key="all" value="all" v-if="admins.length > 0">
              <a-icon 
                :type="isAllMaterialsSelected ? 'check-circle' : 'check-circle-o'"
                style="color: #1890ff; margin-right: 8px" 
              />
              <span style="font-weight: 600">全选</span>
            </a-select-option>
            
            <a-select-option :value="admin.id" v-for="admin in admins" :key="admin.id">
              {{ admin.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="巨量邮箱" prop="juliang_emails"> 
          <a-select mode="multiple"  show-search allow-clear placeholder="请选择" v-model="model.juliang_emails"  option-filter-prop="children">
            <a-select-option :value="item" v-for="(item, index) in emails" :key="index" >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="数据限制" prop="query_limit" help="开启后该用户只能查看近两个月数据">
          <a-switch v-model="model.query_limit" />
        </a-form-model-item>
        <a-form-model-item label="启用" prop="enabled">
          <a-switch v-model="model.enabled"/>
        </a-form-model-item>
        <!-- 【已停用】钉钉登录入口：钉钉登录开关与绑定手机号暂不展示 -->
        <template v-if="false">
          <a-form-model-item label="钉钉登录" prop="open_dingtalk" help="开启管理员只能通过钉钉授权登录后台">
            <a-switch v-model="model.open_dingtalk" />
          </a-form-model-item>
          <a-form-model-item 
            label="手机号" 
            prop="mobiles"
            help="多个手机号用英文逗号,分隔，必须绑定钉钉注册的手机号才可以授权登录"
            v-if="model.open_dingtalk"
          >
            <a-textarea
              v-model="mobilesString"
              :rows="4"
              placeholder="请输入多个手机号，逗号分隔（支持换行）"
            />
          </a-form-model-item>
        </template>
      </a-spin>
      <a-form-model-item label="媒体主体" prop="media_corporations">

        <!-- 1. 选择器 -->
        <a-select
          mode="multiple"
          show-search
          allow-clear
          placeholder="请选择"
          v-model="model.media_corporations"
          :maxTagCount="0" 
          option-filter-prop="children"
        >
          <a-select-option
            :value="item"
            v-for="item in mediaCorporations"
            :key="item"
          >
            {{ item }}
          </a-select-option>
        </a-select>
      
        <!-- 2. 自定义展示区 -->
        <div class="drag-tags-placeholder" v-if="model.media_corporations && model.media_corporations.length === 0">
          暂无已选项，请从上方选择
        </div>
        <div ref="dragContainer" class="drag-tags" v-else>
          <div
            v-for="item in model.media_corporations"
            :key="item"
            class="draggable-tag"
            title="拖动排序"
          >
            <span class="tag-label">{{ item }}</span>
            <span class="tag-close" @click="removeSelected(item)">×</span>
          </div>
        </div>
      </a-form-model-item>
    </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'

export default Create
</script>
